import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ExportService {
  createFileDownloadFromBlob(blob: Blob, filename?: string): void {
    const url = window.URL.createObjectURL(blob);
    if (!url) return;
    this.createFileDownloadFromLink(url, filename ?? 'export.xlsx');
  }

  createFileDownloadFromLink(link: string, filename?: string): void {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    a.href = link;
    if (filename && filename !== '') a.download = filename;
    a.target = '_blank';
    a.click();
  }
}
